import React, { useCallback, useState } from 'react';
import { Form } from 'react-bootstrap';

export function CustomSelect(props) {
    const { value, name, id, size, readOnly, disabled, items, onChange, isInvalid } = props;
    const [selectValue, setSelectValue] = useState(
        items && items.includes(value) ? items.indexOf(value) : value ? 'custom' : ''
    );
    const [inputValue, setInputValue] = useState(selectValue === 'custom' ? value : '');
    const inputType = selectValue === 'custom' ? 'text' : 'hidden';

    const handleSelect = useCallback(
        e => {
            setSelectValue(e.currentTarget.value);
            if (!onChange) return;
            if (e.currentTarget.value === '') onChange(e.currentTarget.value);
            else if (e.currentTarget.value === 'custom') onChange(inputValue);
            onChange(items[e.currentTarget.value]);
        },
        [inputValue, onChange, items]
    );
    const handleInput = useCallback(
        e => {
            setInputValue(e.currentTarget.value);
            if (onChange) onChange(e.currentTarget.value);
        },
        [onChange]
    );

    return (
        <>
            <Form.Control
                isInvalid={isInvalid}
                readOnly={readOnly}
                disabled={disabled}
                value={selectValue}
                size={size}
                onChange={handleSelect}
                as="select"
            >
                <option value="">Не выбрано...</option>
                {items &&
                    items.map((item, i) => (
                        <option key={item} value={i}>
                            {item}
                        </option>
                    ))}
                <option value="custom">Свой вариант</option>
            </Form.Control>
            <Form.Control
                isInvalid={isInvalid}
                name={name}
                id={id}
                readOnly={readOnly}
                disabled={disabled}
                size={size}
                type={inputType}
                onChange={handleInput}
                value={inputValue}
                className="mt-3"
            />
        </>
    );
}
